import { useNavigate } from "react-router";
import Container from "../components/common/Container";
import PageHeader from "../components/common/PageHeader";
import ShiftDefinitionForm, {
  ShiftDefinitionFormValues,
  daysFromRows,
} from "../components/WorkShift/ShiftDefinitionForm";
import { createShiftDefinition } from "../api/shiftDefinitionApi";
import { createNotification } from "../utils/useNotification";

/**
 * Yeni vardiya tanımı (plan 2.24). Haftalık desen tablosu artık
 * `ShiftDefinitionForm` içinde — düzenleme ekranıyla aynı kopya.
 */
const NewWorkShift = () => {
  const navigate = useNavigate();

  const handleSubmit = async (values: ShiftDefinitionFormValues) => {
    const response: any = await createShiftDefinition({
      name: values.name.trim(),
      code: values.code.trim(),
      departmentIds: values.departmentIds,
      days: daysFromRows(values.days),
      dayCutoff: values.dayCutoff || undefined,
      ...(values.lateBufferMinutes !== ""
        ? { lateBufferMinutes: Number(values.lateBufferMinutes) }
        : {}),
      ...(values.earlyLeaveBufferMinutes !== ""
        ? { earlyLeaveBufferMinutes: Number(values.earlyLeaveBufferMinutes) }
        : {}),
      ...(values.notes ? { notes: values.notes } : {}),
    });

    createNotification({
      success: response?.success,
      message: response?.success
        ? "Vardiya oluşturuldu."
        : response?.message ?? "Vardiya oluşturulamadı.",
    });

    if (response?.success) navigate("/shifts/work-shift");
  };

  return (
    <Container>
      <PageHeader
        pageTitle="Yeni Vardiya Tanımı"
        subText="Haftalık çalışma düzeni. Kimlerin bu düzende çalıştığı ayrıca atanır."
      />
      <ShiftDefinitionForm submitLabel="Oluştur" onSubmit={handleSubmit} />
    </Container>
  );
};

export default NewWorkShift;
